import {
  type AccentHue,
  colorize,
  type ShadeTypes,
} from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { type JSXElement, Show } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Icon } from "../components/icon"
import { boxClass, iconClass, outerBoxClass, titleClass } from "./title.css"

type Props = {
  title: string
  subtitle?: JSXElement
  hue: AccentHue
  iconName: IconName
}
export function Title(props: Props) {
  function color(shade: ShadeTypes<AccentHue>) {
    return colorize(props.hue, shade)
  }

  return (
    <Box class={outerBoxClass}>
      <Icon
        class={iconClass}
        name={props.iconName}
        size="32"
        color={color("700")}
      />
      <Box class={boxClass} gap="8" alignItems="center">
        <h1 class={titleClass}>{props.title}</h1>
        <Show when={props.subtitle}>{props.subtitle}</Show>
      </Box>
    </Box>
  )
}
